/* esm.sh - es-toolkit@1.52.0/dist/function/noop */
function o(){}export{o as noop};
//# sourceMappingURL=noop.mjs.map